import ShortCutKey from '../../interaction/shortcutkey/index';
import Transform from '../../interaction/transform';
import Select from '../../interaction/select';

function stageMoveInit(stageCube: CubeNode): void {
    ShortCutKey.on({
        keyName: 'keydown+space',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            stageMatrix.addMask(event);
        }
    });
    ShortCutKey.on({
        keyName: 'mousedown+mousecenter',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            stageMatrix.addMask(event);
        }
    });

    // 按下
    ShortCutKey.on({
        keyName: 'mousedown+space+mouseleft',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            Select.stopAllSelectedAnimation();
            stageMatrix.getStartPos(event);
        }
    });
    ShortCutKey.on({
        keyName: 'mousedown+mousecenter',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            Select.stopAllSelectedAnimation();
            stageMatrix.getStartPos(event);
        }
    });

    // 拖动
    ShortCutKey.on({
        keyName: 'mousemove+space+mouseleft',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            stageMatrix.move(event);
        }
    });
    ShortCutKey.on({
        keyName: 'mousemove+mousecenter',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            stageMatrix.move(event);
        }
    });

    // 抬起
    ShortCutKey.on({
        keyName: 'mouseup+space+mouseleft',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            Select.startAllSelectedAnimationAsync();
            stageMatrix.lastPos();
            Transform.updateTransformConfig();
        }
    });
    ShortCutKey.on({
        keyName: 'mouseup+mousecenter',
        callback: (event) => {
            let stageMatrix: MatrixInstance = Transform.getInstance();

            Select.startAllSelectedAnimationAsync();
            stageMatrix.lastPos();
            stageMatrix.removeMask();
            Transform.updateTransformConfig();
        }
    });

    // 空格键抬起
    ShortCutKey.on({
        keyName: 'keyup',
        callback: (ev) => {
            if (ev.keyCode !== 32) {
                return;
            }
            let stageMatrix: MatrixInstance = Transform.getInstance();

            Select.startAllSelectedAnimationAsync();
            stageMatrix.lastPos();
            stageMatrix.removeMask();
            Transform.updateTransformConfig();
        }
    });
}

export {
    stageMoveInit
};
